// Angular
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild, Output,Input } from '@angular/core'
import { MatPaginator } from '@angular/material'
import { ActivatedRoute, Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
// Services
import { LayoutConfigService } from '../../../../../core/_base/layout'
import { AppService, ConsultationService, ParameterService, StateService,DialogService, VisiteService } from '../../../../../services'

import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'

import { PanierLine } from '../../../../../Interfaces/Panier'
import { LOCATION_INITIALIZED } from '@angular/common'

const KEY = 'PANNIER-ADD'

@Component({
    selector: 'atyl-panier-add',
    templateUrl: './panier-add.component.html',
    styleUrls: ['panier-add.component.scss'],
})
@Stringable({
    path: 'views/pages/dashboard/dashboard',
    key: KEY,
})
export class PanierAddComponent implements OnInit {
   // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
    
    @StringableValues(KEY)
    strings: any
    
    @Input() elementPanier: PanierLine[]=[];
	@Input() elements:any;
	@Input() switch:any=''; 
    
    @Input() dossier: any;
    @Input() instruction: any;
	@Input() consultation: any;
	@Input() date_debut:any;
	@Input() date_fin:any;
	@Input() type:any;
	@Input() classPanier:any;
		
    
    @Input() disabled:boolean=false;
	tiersID: any;
    
    constructor(

	    private dialogService: DialogService,
        private layoutConfigService: LayoutConfigService,
        private parameterService: ParameterService,
        private stateService: StateService,
        private router: Router,
        private appService: AppService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private consultationService: ConsultationService,
		private visiteService: VisiteService,
    ) {
    }

    
    ngOnInit(): void {

    }

    ngOnDestroy() {

    }


    addtoCart() {

		this.dialogService.open(ConfirmComponent, {
			draggable: true,
			resizable: false,
			minimizable: false,
			maximizable: false,
			width: '25vw',
			height: '25vh',
			data: {
				libelle: `Etes-vous sûr de vouloir ajouter à vos lots ?`,
			}
		}, (res: any) => {
			if (res) {
				console.log("elementPanier PanierAdd",this.elementPanier)
				if(this.elementPanier){
					for(let i=0;i<this.elementPanier.length;i++){
						let line:PanierLine=new PanierLine();
						line.id=this.getUniqueId(4);
						line.user=this.stateService.user.value.id;
						if (this.elementPanier[i].dossier){
							if(this.elementPanier[i].dossier != undefined 
							&& this.elementPanier[i].dossier != ""){
								line.dossier=this.elementPanier[i].dossier;
							} else {
								line.dossier = "";
							}
						} else {
							line.dossier = '';
						}

						if(this.elementPanier[i].instruction){
							if(this.elementPanier[i].instruction != undefined 
								&& this.elementPanier[i].instruction != ""){
								line.instruction=this.elementPanier[i].instruction;
							} else {
								line.instruction = "";
							}
						} else {
							line.instruction = '';
						} 

						if(this.elementPanier[i].consultation){
							if(this.elementPanier[i].consultation != undefined 
							&& this.elementPanier[i].consultation != ""){
								line.consultation = this.elementPanier[i].consultation;
							} else {
								line.consultation = "";
							}
						} else {
							line.consultation = "";
						}

						if(this.elementPanier[i].visite){
							if(this.elementPanier[i].visite != undefined 
							&& this.elementPanier[i].visite != ""){
								line.visite = this.elementPanier[i].visite;
							} else {
								line.visite = "";
							}
						} else {
							line.visite = "";
						}

						this.stateService.addPanierLine(line);
						this.changeDetectorRef.detectChanges();
					}
				} else {
					return("aucune donnée a ajouter dans vos lots")
				}
			}
		})
	}
	
	getUniqueId(parts: number): string {

		const stringArr = [];
		for(let i = 0; i< parts; i++){
			// tslint:disable-next-line:no-bitwise
			const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			stringArr.push(S4);
		}
		return stringArr.join('-');
	}
	
}
